/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {CdnUploadListPageComponent} from './cdn-upload-list-page.component';

@Component({
  standalone: true,
  imports: [CdnUploadListPageComponent],
  selector: 'adn-cdn-upload-route-page',
  template: `
    <adn-cdn-upload-list-page [readOnly]="readOnly"></adn-cdn-upload-list-page>
  `
})
export class CdnUploadRoutePageComponent {
  @Input() readOnly = false;
}
